
export enum RuleOverrideReasonCd {
	SRN_AVAILABLE_NOT_VALID = 'SrnAvailableNotValid',
	SRN_NOT_AVAILABLE = 'SrnNotAvailable'}

